import RestResource from '../rest.service';

export default class PermissionsService extends RestResource {
  constructor() {
    super('permissions');
  }
}
